import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
	sectionHeader: {
		fontSize: 16,
		fontWeight: 'bold',
		marginBottom: 12,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
});

interface PdfSectionProps {
	title: string,
	description?: string,
	unitCount?: string,
	showDivider?: boolean,
	children: React.ReactNode,
}

const PdfSection = (props: PdfSectionProps) => {
	const {
		title,
		children,
		unitCount,
		showDivider = true,
		description,
	} = props;

	return (
		<View>
			<View style={[
				styles.sectionHeader,
				showDivider ? {
					borderBottom: '1px solid #E3E3E3',
					paddingBottom: 8,
				} : {},
			]}
			>
				<Text>{title}</Text>
				{unitCount && (
					<Text>{unitCount}</Text>
				)}
			</View>
			{description && (
				<Text style={{ marginBottom: 18 }}>{description}</Text>
			)}
			{children}
		</View>
	);
};

export default PdfSection;
